import { Component, Input, OnInit } from '@angular/core'
import { environment } from '../../../environments/environment'
import { ApiService } from '../../services/api.service'
@Component({
  selector: 'external-org-members',
  templateUrl: './external-org-members.component.html',
  styleUrls: ['./external-org-members.component.scss'],
})
export class ExternalOrgMembersComponent implements OnInit {
  @Input() orgUuid: string

  public data
  public baseUrl

  constructor(private apiService: ApiService) {
    this.baseUrl = `${environment.accountsUrl}/external/organizations/`
  }

  ngOnInit() {
    this.apiService.getExternalOrgMembers(this.orgUuid).subscribe((data) => {
      this.data = JSON.stringify(data, null, 2)
    })
  }
}
